import { type ButtonVariant } from '@pixum/button';
import { ButtonCollection } from '../../buttonCollection';
import type { Device, LinkNode } from 'data-layer';
import { CREATIVE_ID } from 'hooks';

type OrderWayActionsProps = {
  actions: LinkNode[];
  ctaVariant: ButtonVariant;
  device: Device;
  inDialog?: boolean;
  isFocused?: boolean;
};

export function OrderWayActions({ actions, ctaVariant, device }: OrderWayActionsProps) {
  const buttonPropsTransformer = (button: LinkNode, device: 'mobile' | 'desktop', index: number) => ({
    link: button,
    className: `orderWay__button--${ctaVariant}-${device}`,
    variant: ctaVariant,
    device,
    id: `orderWay-${ctaVariant}-button-${index}`
  });

  return (
    <ButtonCollection
      buttons={actions}
      device={device}
      creativeId={CREATIVE_ID.CONTENT}
      buttonPropsTransformer={buttonPropsTransformer}
    />
  );
}
